import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import _ from 'lodash';
import { addAccessorial, updateAccessorial } from '../../services/accessorialServices';
import { isNTMSUSer } from '../../utils/roleUtils';
import { fetchAccountType } from '../../services/accountTypeServices';
import ModalRender from '../Commons/ModalRender';
import { useDispatch, useSelector } from 'react-redux';
import { addAccessorialData, setAccessorialData } from '../../redux/accessorial/accessorialReducer';
import PrimaryDetails from './PrimaryDetails';
import FormTabs from '../Commons/Layouts/FormTabs';
import { setFormPendingCompletion, setFormPendingFunction, setNotificationData } from "../../redux/global/globalReducer";
import { updateFormDataOnExit } from '../../utils/formUtils';

function AccessorialForm({
  isFormEdit = false,
  selectedAccessorial = {},
  isFormHidden,
  toggleFormDisplay,
  setIsFormDirty,
  modal,
  setModal,
  toggle,
  focusOnOpenOrCloseButton
}) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    setFocus,
    control,
    formState
  } = useForm();
  const { dirtyFields, errors, isDirty } = formState;
  const userType = useSelector((state) => state.auth.user.userType);
  const [accountType, setAccountType] = useState("")
  const [currencyType, setCurrencyType] = useState("")
  const [defaultTaxCode, setDefaultTaxCode] = useState("")
  const accountId = useSelector((state) => state.auth.user.accountId);
  const accountState = useSelector((state) => state.account.selectedAccount);
  const isInitialRender = useRef(true);

  // useStates
  const [accountTypeList, setAccountTypeList] = useState([])

  // useEffects
  useEffect(() => {
    clearErrors();
    fillAccountType();
  }, []);

  useEffect(() => {
    clearErrors();
    reset();
    if (!isFormHidden) {
      setTimeout(() => {
        setFocus("accessorialName");
      }, 50);
    }
  }, [isFormHidden]);

  useEffect(() => {
    const updateForm = async () => {
      await updateFormDataOnExit(
        dispatch,
        !_.isEmpty(dirtyFields),
        setIsFormDirty,
        isFormEdit,
        _.isEmpty(errors),
        handleSubmit,
        onSubmit
      )
    }

    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    updateForm();
  }, [formState])

  const fillAccountType = async () => {
    const response = await fetchAccountType();
    setAccountTypeList(response);
  }

  const onSubmit = async (payload, keepAlive = false) => {
    let response = null;
    if (isFormEdit) {
      _.set(payload, 'accessorialId', selectedAccessorial.accessorialId);
      _.set(payload, 'accountId', accountId);
      response = await updateAccessorial(payload, keepAlive);
      dispatch(
        setNotificationData({
          type: `${response.ok ? "success" : "error"}`,
          message: `${response.ok ? "Success!" : "Error!"}`,
          description: `${response.ok ? "Successfully saved" : "Failed to save"
            } accessorial.`,
        })
      );
    } else {
      _.set(payload, 'accessorialId', 0);
      _.set(payload, 'master', false);
      if (isNTMSUSer(userType)) {
        _.set(payload, 'accountId', accountState.accountId != null ? accountState.accountId : accountId);
      } else {
        _.set(payload, 'accountId', accountId);
      }
      response = await addAccessorial(payload, keepAlive);
      dispatch(
        setNotificationData({
          type: `${response.ok ? "success" : "error"}`,
          message: `${response.ok ? "Success!" : "Error!"}`,
          description: `${response.ok ? "Successfully saved" : "Failed to save"
            } accessorial.`,
        })
      );
    }

    if (response.ok) {
      const accessorialData = await response.json();
      dispatch(isFormEdit ? setAccessorialData(accessorialData) : addAccessorialData(accessorialData));

      if (isDirty) {
        setModal(false);
      }
      setIsFormDirty(false);
      dispatch(setFormPendingCompletion(false));
      reset({}, {keepValues: true});
      return true;
    }
    return false;
  }

  const tabItems = [
    {
      label: "Primary Details",
      key: 0,
      forceRender: true,
      children: (
        <div className="content-section-container color-6-section">
          <div className="row form-container" id="primary-details-form">
            <PrimaryDetails
              isFormEdit={isFormEdit}
              isFormHidden={isFormHidden}
              setIsFormDirty={setIsFormDirty}
              selectedAccessorial={selectedAccessorial}
              control={control}
              register={register}
              errors={errors}
              setValue={setValue}
              reset={reset}
              accountTypeList={accountTypeList}
            />
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <form id="accessorial-form" onSubmit={handleSubmit(async (payload) => onSubmit(payload, false))}>
        <FormTabs
          items={tabItems}
          tabClassName="color-6"
          isFormHidden={isFormHidden}
        />

        <div className="row mt-5">
          <div className="col-12">
            <div className="d-flex flex-row align-items-center">
              <button className={`ms-auto btn btn-primary`} type="submit">
                Save
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  )
}

export default AccessorialForm
